import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Pagination, PaginationRequest } from 'src/app/core/models/pagination.model';
import { ConfigService } from 'src/app/core/services/config.service';

@Component({
  selector: 'hbo-analytics-table',
  templateUrl: './analytics-table.component.html',
  styleUrls: ['./analytics-table.component.scss']
})
export class AnalyticsTableComponent implements OnInit, OnChanges {

  @Input() items!: Pagination<unknown>;
  @Input() columns!: string[];
  @Input() typeData!: string;
  @Output() reload = new EventEmitter<PaginationRequest>();
  @Input() page!: string;
  @Input() sortableColumns: string[] = [];
  @Output() sortChange = new EventEmitter<{ sort: string; order: 'asc' | 'desc' | '' }>();

  currentSort: string = '';
  currentOrder: 'asc' | 'desc' | '' = '';

  pagination: PaginationRequest = {
    page: 1,
    perPage: 10,
    sort: '',
    order: '',
    search: ''
  }

  constructor(
    public configSvc: ConfigService
  ) {

  }

  ngOnInit() : void {
    this.syncPaginationFromItems();
    switch (this.page) {
      default:
        break;
    }
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this.syncPaginationFromItems();
  }

  private syncPaginationFromItems(): void {
    if (!this.items) return;

    this.pagination.page = this.items.currentPage || 1;
    this.pagination.perPage = this.items.perPage < 0 ? 10 : this.items.perPage;
    this.pagination.sort = this.items.sort;
    this.pagination.order = this.items.order;
    this.pagination.search = this.items.search;
    this.currentSort = this.items.sort || '';
    this.currentOrder = (this.items.order as 'asc' | 'desc' | '') || '';
  }

  onPageChanged(page = 1) {
    this.pagination.page = page;
    this.reload.emit(this.pagination);
  }

  sortBy(column: string) {
    if (this.currentSort === column) {
      if (this.currentOrder === 'asc') {
        this.currentOrder = 'desc';
      } else if (this.currentOrder === 'desc') {
        this.currentOrder = '';
        this.currentSort = '';
      } else {
        this.currentOrder = 'asc';
      }
    } else {
      this.currentSort = column;
      this.currentOrder = 'asc';
    }
    this.sortChange.emit({ sort: this.currentSort, order: this.currentOrder });
  }

}
